import { createHashRouter, createRoutesFromElements, Navigate, Route } from 'react-router';

import RouteErrorFallback from '#components/error/RouteErrorFallback.tsx';

import AppLayout from '../layout/AppLayout';
import { TourServicePage } from '../pages/TourServicePage';
import { routes } from './routes';

const routesFromElements = createRoutesFromElements(
    <>
        <Route element={<AppLayout />} errorElement={<RouteErrorFallback />}>
            <Route path={routes.TOURSERVICE} element={<TourServicePage />}>
                <Route path=':tourId' element={<TourServicePage />} />
            </Route>
        </Route>
        <Route path='*' element={<Navigate to={routes.DEFAULT} />} />
    </>
);

export const appRouter = createHashRouter(routesFromElements);
